export const Mode = {
  NEW: 0,
  EDIT: 1,
};
